import { withStyles, TableCell } from "@material-ui/core";

export const StickyColumn = withStyles((theme) => ({
    root: {
        zIndex: 9, 
        position: 'sticky', 
        top: 0, 
        left: 0,
    }
}))(TableCell);